/* eslint-disable @typescript-eslint/no-unused-vars */
 
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { KeycloakAuthGuard, KeycloakService } from '@inoventoryapps/keycloak-angular';
import { UserService } from '../_services/_user/user.service';
import { LocalService } from '../_services/_storage/local.service';
import { SnackbarService } from '../_services/snackbar/snackbar.service';
import { LOCALSTORAGEKEYS } from '../_constants/localStorageKeys';

@Injectable({
    providedIn: 'root'
})
export class AuthKeycloakGuard extends KeycloakAuthGuard {

    static currentRouteRoles = [];

    constructor(
    protected _router: Router,
    protected _keycloakAngular: KeycloakService,
    protected _user: UserService,
    private localService: LocalService,
    private snackbarService: SnackbarService
    ) {
        super(_router, _keycloakAngular);
    }

    isAccessAllowed(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
        return new Promise(async (resolve, reject) => {
            const userRoles = this.localService.get(LOCALSTORAGEKEYS.USERROLES);
            const routeRoles = route.data['allowedRoles'];
            AuthKeycloakGuard.currentRouteRoles = route.data['allowedRoles'];
            let permission = false;

            if (!this.authenticated) {
                this.keycloakAngular.login({ idpHint: '' }).catch((e) => console.error(e));
                return reject(false);
            } else {
            }

            if (routeRoles.includes('all')) {
                permission = true;
            }
            else {
                if (!userRoles || userRoles.length === 0) {
                    permission = false;
                }

                if (routeRoles.length > 0) {
                    routeRoles.forEach((role: any) => {
                        if (userRoles.includes(role)) {
                            permission = true;
                        }
                    });
                }
            }

            if (permission === true) {
                resolve(true);
            }
            else {
                resolve(false);
                this.snackbarService.errorSnackbar('You do not have permission to access this page');
                this._router.navigate(['/unauthorised-access']);
            }
        });
    }
}
